import { caseInsensitiveSort } from '@/lib/sort';
import type { MemberStatus, State } from './types';
import { memoize } from '@/lib/memoize';

export type Mutation = { type: 'setMemberStatus'; data: MemberStatus[] };

export function reducer(state: State, action: Mutation) {
  switch (action.type) {
    case 'setMemberStatus':
      return setMemberStatus(state, action);
    default:
      return state;
  }
}

function setMemberStatus(
  _state: State,
  { data }: { data: MemberStatus[] },
): State {
  return {
    lookup: memoize(data, 'key'),
    list: data.sort(caseInsensitiveSort(['key'])),
    loaded: true,
  };
}
